import React from 'react'
import styled, { keyframes } from 'styled-components'

const breatheAnimation = keyframes`
 0% { height: 0px; width: 0px; opacity: 1; }


 100% { height: 45px; width: 45px; opacity: 0; }
`
const Circle = styled.div`
 height: 45px;
 width: 45px;
 border-style: solid;
 border-width: 0px;
 border-radius: 50%;
  justify-content:center;
  transform-origin: center;
 background-color: #00FFF9;
 animation-name: ${breatheAnimation};
 animation-duration: 1.9s;
 animation-iteration-count: infinite;

`
const Container = styled.div`
 display: flex;
 align-items: center;
 transform-origin: center;
 align-self:center;
 justify-content: center;
 flex-direction: column;
 margin-left:0px;
 height: 45px;
 width:45px;
 position:absolute;
 z-index:1;
`

const Breathe = () => {
 return (
  <Container>
   <Circle />
  </Container>
 )
}

 export default Breathe;